var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 10.0003C14.1668 14.167 11.2502 16.2503 7.7835 17.4586C7.60196 17.5201 7.40478 17.5172 7.22516 17.4503C3.75016 16.2503 0.833496 14.167 0.833496 10.0003V4.16696C0.833496 3.94595 0.921294 3.73398 1.07757 3.5777C1.23385 3.42142 1.44582 3.33363 1.66683 3.33363C3.3335 3.33363 5.41683 2.33363 6.86683 1.06696C7.04337 0.916126 7.26796 0.833252 7.50016 0.833252C7.73237 0.833252 7.95695 0.916126 8.1335 1.06696C9.59183 2.34196 11.6668 3.33363 13.3335 3.33363C13.5545 3.33363 13.7665 3.42142 13.9228 3.5777C14.079 3.73398 14.1668 3.94595 14.1668 4.16696V10.0003Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.084c436390316c1ad7f4b06e801019c5.svg";
export { ForwardRef as ReactComponent };